import { render } from "./ProposalTickets.vue?vue&type=template&id=5a43a18d"
import script from "./ProposalTickets.vue?vue&type=script&lang=js"
export * from "./ProposalTickets.vue?vue&type=script&lang=js"

import exportComponent from "Q:\\grdn-mr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__